import { render, staticRenderFns } from "./SavedForumCommentCard.vue?vue&type=template&id=f83d78e2&scoped=true&"
import script from "./SavedForumCommentCard.vue?vue&type=script&lang=js&"
export * from "./SavedForumCommentCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83d78e2",
  null
  
)

export default component.exports